import { Service, signal } from '@angular/core';

/**
Whether a fatal, post-bootstrap application error has occurred.

Written only by `FatalErrorListener`; read by `FatalErrorOverlay` to
decide whether to render its full-viewport error state.
*/
@Service()
export class FatalErrorState {
  readonly failed = signal(false);

  markFailed(): void {
    this.failed.set(true);
  }
}
